module.exports = __webpack_public_path__ + "static/menu_get_coupons.0d951222.png";